import React from "react";
import PRO3Features from "./brand_widgets/PRO3Features";
import CUFeatures from "./brand_widgets/CUFeatures";
import UCFeatures from "./brand_widgets/UCFeatures";
const BrandFeatures = props => {

    const formatNumberValue = (value) => {
    // Convert Indian number format (1,00,000) to US format (100,000)
    const convertIndianToUSFormat = (value) => {
      if (!value || typeof value !== 'string') return value;
      
      // Remove all commas first
      const numberWithoutCommas = value.replace(/,/g, '');
      
      // Check if it's a valid number
      if (isNaN(numberWithoutCommas)) {
        return value;
      }
      
      // Convert to number and back to string with US formatting
      const number = parseFloat(numberWithoutCommas);

      // Format with US comma separation (every 3 digits)
      const result = number.toLocaleString('en-US');    
      return result;
    };
    
    // Actually use the conversion function
    return convertIndianToUSFormat(value);
  };

  if (
    props.type == "HCU" ||
    props.type == "VCU" ||
    props.type == "DVCU" ||
    props.type == "VCU_DVCU" ||
    props.type == "HTS"
  ) {
    return <CUFeatures {...props} formatNumberValue={formatNumberValue}></CUFeatures>;
  } else if (
    props.type == "LOP" ||
    props.type == "CM" ||
    props.type == "LVCM" ||
    props.type == "LUC" ||
    props.type == "MP"
  ) {
    return <UCFeatures {...props} formatNumberValue={formatNumberValue}></UCFeatures>;
  } else if (
    props.type == "PRO3" &&
    typeof props.modelnumber != "undefined" &&
    props.modelnumber !== "Call Factory"
  )
    return <PRO3Features {...props} formatNumberValue={formatNumberValue}></PRO3Features>;
  else return <div></div>;
};

export default BrandFeatures;
